/*
 * @Author: 处方流转相关路由
 * @Date: 2021-12-03 09:30:34
 * @LastEditTime: 2021-10-21 15:49:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 */

export default [{
        path: "/recipeFlow/recipeList",
        name: "recipeList",
        component: resolve => require(["@/views/recipe-flow/recipe-list"], resolve),
        meta: {
            title: "处方流转"
        }
    },
    {
        path: "/recipeFlow/recipeUnpaid",
        name: "recipeUnpaid",
        component: resolve => require(["@/views/recipe-flow/recipe-unpaid"], resolve),
        meta: {
            title: "处方流转"
        }
    }
];


// WEBPACK FOOTER //
// ./src/router/modules/recipe-flow.js